<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="dark" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="logo_white.png" alt="logo" style="height : 45px">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/">
                        <img src="logo_black.png" style="height : 65px">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <router-link to="/" class="nav-link text-white"><b>Home</b></router-link>
                </li>              
                <li class="nav-item">
                    <router-link to="/contact-me" class="nav-link text-white"><b>Contact Me</b></router-link>
                </li>
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="" target="_blank"
                       class="btn btn-neutral btn-icon">
                        <span class="btn-inner--icon">
                            <i class="fa fa-calendar mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text">Book Now</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
